const FinishesColors = () => {
  const finishesCards = [...document.querySelectorAll(".finishes__item")];

  const updateColorsLayout = () => {
    const screenWidth = window.innerWidth;
    let oneLineHeight;

    if (screenWidth >= 1441) {
      oneLineHeight = 36;
    } else if (screenWidth >= 1024) {
      oneLineHeight = 32;
    } else if (screenWidth >= 768) {
      oneLineHeight = 28;
    } else {
      oneLineHeight = 24;
    }

    finishesCards.forEach((finishesCard) => {
      const colorsBlock = finishesCard.querySelector(".finishes__item-colors-block");

      if (colorsBlock) {
        const colorsList = colorsBlock.querySelector(".finishes__item-colors-list");
        const btn = colorsBlock.querySelector(".finishes__item-colors-btn");

        colorsList.classList.remove("overflown");
        btn.classList.remove("d-none");

        if (colorsList.offsetHeight <= oneLineHeight) {
          btn.classList.add("d-none");
        } else {
          colorsList.classList.add("overflown");
        }

        if (btn) {
          if (!btn.dataset.listenerAdded) {
            btn.addEventListener("click", () => {
              colorsBlock.classList.toggle("opened");
              finishesCard.classList.toggle("opened");
            });
            btn.dataset.listenerAdded = true; 
          }
        }
      }
    });
  };

  updateColorsLayout();

  window.addEventListener("resize", updateColorsLayout);
};

export default FinishesColors;

